/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {IErrorObject} from "../../../../../types/platform/universe";
import {Guests2Service} from "../guests2.service";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {Router} from "@angular/router";
import {BaseDialogComponent} from "../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-guest-username-dialog",
	styleUrls: ["./guest-username-dialog.component.css"],
	templateUrl: "./guest-username-dialog.component.html",
})
export class GuestUserNameDialogComponent extends BaseDialogComponent implements OnInit {

	/**
	 * todo
	 */
	get content(): any {
		return this.data.content;
	}

	/**
	 *
	 * @param data
	 * @param matDialogRef
	 * @param matDialog
	 * @param snackbar
	 * @param auth
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<GuestUserNameDialogComponent>,
		private matDialog: MatDialog,
		public snackbar: MatSnackBar,
		public auth: Guests2Service,
		public translate: TranslateService
	) {
		super();
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.Progress(false);
	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		this.Progress(true);
		this.auth.username_immediate(this.content.user_id, this.content.username, (error: IErrorObject, result: any) => {
			if (!error) {
				this.matDialogRef.close(this.data);
			} else {

			}
			this.Progress(false);
		});
	}

}
